import { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { View } from 'foundations-components/components/View';
import CampaignSelectFormControl from 'campaigns-lib/components/campaignSelect/CampaignSelectFormControl';
import { useFetchAssociatedCampaign } from 'asset-actions-lib-forms/selectCampaign/hooks/useFetchAssociatedCampaign';
import { jsx as _jsx } from "react/jsx-runtime";
const WidthCampaignSelectFormControl = styled(CampaignSelectFormControl).withConfig({
  displayName: "FormsCampaignSelect__WidthCampaignSelectFormControl",
  componentId: "sc-1vfos72-0"
})(["max-width:100% !important;"]);
const FORM_CRM_OBJECT_TYPE = 'FORM';
export default function FormsCampaignSelect({
  formGuid,
  onChange,
  hasCampaignsReadAccess,
  hasCampaignsWriteAccess,
  selectedCampaignGuid
}) {
  const {
    data: associatedCampaign,
    loading
  } = useFetchAssociatedCampaign({
    formGuid,
    skip: !hasCampaignsReadAccess
  });
  useEffect(() => {
    if (!loading && associatedCampaign) {
      onChange(associatedCampaign);
    }
  }, [associatedCampaign, loading, onChange]);
  const onSelectCampaign = useCallback(({
    target: {
      value
    }
  }) => {
    onChange(value);
  }, [onChange]);
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1000",
    children: /*#__PURE__*/_jsx(WidthCampaignSelectFormControl, {
      "data-test-id": "forms-campaign-select",
      hasCampaignsReadAccess: hasCampaignsReadAccess,
      hasCampaignsWriteAccess: hasCampaignsWriteAccess,
      value: selectedCampaignGuid || undefined,
      onChange: onSelectCampaign,
      assetObjectType: FORM_CRM_OBJECT_TYPE,
      withCampaignAutoSelectPopover: true
    })
  });
}